<template>
  <v-form ref="newNpo" class="pa-4" v-model="formValid">
    <div class="text-h5">Npo details</div>
    <v-container>
      <v-row>
        <v-col
          cols="12"
        >
    <v-form-base
      :value="npoDetails.data.npo"
      :schema="newClientSchema.npo"
    />
    <div class="text-h5">Legal Representative or delegated</div>
    <v-form-base
      id="npo-details"
      :value="npoDetails.data.contacts.rappresentante"
      :schema="newClientSchema.contacts.rappresentante"
    />
    <div class="text-h5">Tecnical Contact</div>
    <v-form-base
      :value="npoDetails.data.contacts.referente"
      :schema="newClientSchema.contacts.referente"
    />
        </v-col>
      </v-row>
      </v-container>
    <v-btn color="primary" @click="registerNpo()">Create Npo</v-btn>
    <v-btn class="ml-4" color="secondary" outlined @click="resetForm"
      >Cancel</v-btn
    >
  </v-form>
</template>

<script>
import apiService from '@/services'
import { mapState, mapActions } from 'vuex'
import provinces from '../assets/provinces.js'
import validationRules from '@/mixins'

export default {
  name: 'NpoRegistrationForm',

  // eslint-disable-next-line vue/no-unused-components
  components: {
    VFormBase: () => import('vuetify-form-base')
  },
  mixins: [validationRules],
  data () {
    return {
      campaignsList: [],
      formValid: true,
      npoDetails: {
        formTitle: 'New Npo',
        data: {
          npo: {
            name: null
          },
          contacts: {
            rappresentante: {
              first_name: null
            },
            referente: {
              first_name: null
            }
          }
        }
      },
      showPage: false,
      provinces: provinces,
      isValid: true
    }
  },
  computed: {
    ...mapState({
      auth: 'auth',
      alerts: (state) => state.alert.snackbars
    }),
    // Get general entity statuses from store
    ...mapState('init', ['statuses', 'interventionAreas']),

    newClientSchema () {
      let campaignsList = this.campaignsList
      return {
        npo: {
          name: {
            type: 'text',
            label: 'Name *',
            flex: 12,
            rules: [this.validationRules.requiredField('Name')]
          },
          description: {
            type: 'textarea',
            label: 'Description',
            counter: 1500,
            maxlength: 1500,
            flex: 12
          },
          fiscal_code: {
            type: 'text',
            label: 'Fiscal Code *',
            flex: 12,
            counter: 11,
            maxlength: 11,
            rules: [
              this.validationRules.requiredField('Fiscal code'),
              // this.validationRules.requiredlength('Fiscal code', 11)
              (v) => (v && v.length <= 11) || `Fiscal code must be 11 maximum characters`
            ]
          },
          vat_number: {
            type: 'text',
            label: 'Vat Number',
            counter: 11,
            flex: 12,
            mask: '###########',
            maxlength: 11,
            rules: [
              this.validationRules.requiredlength('Vat Number', 11)
            ]
          },
          address: {
            type: 'text',
            label: 'Address',
            flex: 4
          },
          zip_code: {
            type: 'text',
            label: 'Zip Code',
            mask: '#####',
            maxlength: 5,
            flex: 2,
            counter: 5,
            rules: [
              this.validationRules.requiredlength('Zip Code', 5)
            ]
          },
          state: {
            type: 'text',
            label: 'State',
            flex: 4
          },
          city: {
            type: 'text',
            label: 'City',
            flex: 4
          },
          province: {
            type: 'text',
            label: 'Province',
            flex: 2,
            rules: [
              this.validationRules.requiredlength('Province', 2)
            ]
          },
          campaign_id: {
            type: 'select',
            label: 'Campaign',
            clearable: false,
            items: campaignsList,
            itemValue: 'id',
            itemText: 'name',
            flex: { xs: 12, sm: 6 }
          },
          intervention_areas: {
            type: 'select',
            multiple: true,
            label: 'Intervention areas',
            clearable: false,
            items: this.interventionAreas,
            itemValue: 'id',
            itemText: 'description',
            flex: { xs: 12, sm: 6 }
          },
          iban: {
            type: 'text',
            label: 'Iban',
            flex: 12,
            counter: 27,
            rules: [
              this.validationRules.requiredlength('Iban', 27)
            ]
          },
          website: {
            type: 'text',
            label: 'Website',
            flex: 12
          },
          facebook: {
            type: 'text',
            label: 'Facebook',
            flex: 12
          }
        },
        contacts: {
          referente: {
            first_name: {
              type: 'text',
              label: 'First name  *',
              flex: 6,
              rules: [this.validationRules.requiredField('First name')]
            },
            last_name: {
              type: 'text',
              label: 'Last name *',
              flex: 6,
              rules: [this.validationRules.requiredField('Last name')]
            },
            email: {
              type: 'text',
              label: 'Email *',
              flex: 6,
              rules: [
                this.validationRules.requiredField('Email'),
                (v) => /.+@.+\..+/.test(v) || 'Email must be valid'
              ]
            },
            phone: {
              type: 'text',
              label: 'Phone',
              flex: 6
            }
          },
          rappresentante: {
            first_name: {
              type: 'text',
              label: 'First name *',
              flex: 6,
              rules: [this.validationRules.requiredField('First name')]
            },
            last_name: {
              type: 'text',
              label: 'Last name *',
              flex: 6,
              rules: [this.validationRules.requiredField('Last name')]
            },
            email: {
              type: 'text',
              label: 'Email *',
              flex: 6,
              rules: [
                this.validationRules.requiredField('Email'),
                (v) => /.+@.+\..+/.test(v) || 'Email must be valid'
              ]
            },
            phone: {
              type: 'text',
              label: 'Phone',
              flex: 6
            }
          }
        }
      }
    }
  },
  created () {
    this.getCampaignsList()
  },
  methods: {
    ...mapActions('layoutevents', ['closeRightDrawer']),

    /**
     * Lists
     */
    getCampaignsList () {
      // GET on global entities search API endpoint
      apiService
        .fetchData('campaigns')
        .then((response) => {
          setTimeout(() => {
            this.campaignsList = response
          }, 800)
        })
        .catch((error) => {
          this.$store.dispatch('alert/showSnackbar', {
            color: 'error',
            text: `Cannot get campaigns ${error}`
          })
        })
    },
    setSnackbar (status, message) {
      this.$store.dispatch('showSnackbar', {
        color: status,
        showing: true,
        text: message
      })
    },
    registerNpo () {
      // Aggiorna npo con codice fiscale
      if (this.$refs.newNpo.validate()) {
        this.npoDetails.data.is_admin_request = true
        this.npoDetails.data.npo.status = 1
        apiService
          .newNpo(this.npoDetails.data.npo)
          .then(response => {
            this.$emit('npo-registered')
            this.$store.dispatch('alert/showSnackbar', {
              color: 'success',
              text: 'Npo registrata con successo'
            })

            // Register contacts
            this.npoDetails.data.contacts.rappresentante.is_legal_rep = true
            apiService
              .createContact('npos', response.id, this.npoDetails.data.contacts.referente)
              .catch(error => {
                this.$store.dispatch('alert/showSnackbar', {
                  color: 'error',
                  text: error
                })
              })

            this.npoDetails.data.contacts.referente.is_tech_rep = true
            apiService
              .createContact('npos', response.id, this.npoDetails.data.contacts.rappresentante)
              .catch(error => {
                this.$store.dispatch('alert/showSnackbar', {
                  color: 'error',
                  text: error
                })
              })

            // Set data for npo campaign association
            const data = {
              npo_id: response.id,
              campaign_id: this.npoDetails.data.npo.campaign_id
            }

            apiService
              .associateNpo(data)
              .catch(error => {
                this.$store.dispatch('alert/showSnackbar', {
                  color: 'error',
                  text: error
                })
              })

            // Register areas
            if (this.npoDetails.data.npo.intervention_areas) {
              this.npoDetails.data.npo.intervention_areas.forEach(area => {
                apiService
                  .associateArea('npo', response.id, area)
                  .catch((error) => {
                    this.$store.dispatch('alert/showSnackbar', {
                      color: 'error',
                      text: error
                    })
                  })
              })
            }
            this.closeRightDrawer()
          })
          .catch(error => {
            console.log(error)
            this.$store.dispatch('alert/showSnackbar', {
              color: 'error',
              text: 'Errore nella registrazione dell\'Npo'
            })
          })
      } else {
        this.$store.dispatch('alert/showSnackbar', {
          color: 'error',
          text: 'Form non compilato correttamente.'
        })
      }
    },
    resetForm () {
      this.$refs.newNpo.reset()
      this.closeRightDrawer()
    }
  }
}
</script>
<style scoped>
input[type="number"] {
  -moz-appearance: textfield;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
</style>
